import React, { useEffect, useState } from "react";
import { routes } from "../General";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { Card, CardHeader, Collapse, Container } from "reactstrap";

export const Asegurados = ({ cdObjetoCotizacion, cdCompania, item }) => {
    const [list, setList] = useState([]);
    const [open, setOpen] = useState(false);

    const openCollapse = () => {
        setOpen(!open);
    };

    useEffect(() => {
        if (cdObjetoCotizacion && cdCompania) {
            getDpendiente(cdObjetoCotizacion, cdCompania);
        }
    }, [cdObjetoCotizacion, cdCompania]);

    const getDpendiente = (cdObjCotizacion, cdCompania) => {
        axios
            .get(routes.api + "/subObjeto", {
                params: {
                    cdObjCotizacion: cdObjCotizacion,
                    cdCompania: cdCompania,
                },
            })
            .then(resp => {
                setList(resp.data);
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    const calcularEdad = fecha => {
        //dar formato a las fecha
        fecha = moment(fecha).locale("moment/locale/es").local().format("DD-MM-YYYY");

        let values = fecha.split("-");
        let dia = parseInt(values[0]);
        let mes = parseInt(values[1]);
        let ano = parseInt(values[2]);

        // cogemos los valores actuales
        let fecha_hoy = new Date();
        let ahora_ano = fecha_hoy.getYear();
        let ahora_mes = fecha_hoy.getMonth() + 1;
        let ahora_dia = fecha_hoy.getDate();

        // realizamos el calculo
        let edad = ahora_ano + 1900 - ano;
        if (ahora_mes < mes) {
            edad--;
        }
        if (mes === ahora_mes && ahora_dia < dia) {
            edad--;
        }
        if (edad > 1900) {
            edad -= 1900;
        }

        // calculamos los meses
        let meses = 0;

        if (ahora_mes > mes && dia > ahora_dia) meses = ahora_mes - mes - 1;
        else if (ahora_mes > mes) meses = ahora_mes - mes;
        if (ahora_mes < mes && dia < ahora_dia) meses = 12 - (mes - ahora_mes);
        else if (ahora_mes < mes) meses = 12 - (mes - ahora_mes + 1);
        if (ahora_mes === mes && dia > ahora_dia) meses = 11;

        // calculamos los dias
        let dias = 0;
        if (ahora_dia > dia) dias = ahora_dia - dia;
        if (ahora_dia < dia) {
            let ultimoDiaMes = new Date(ahora_ano, ahora_mes - 1, 0);
            dias = ultimoDiaMes.getDate() - (dia - ahora_dia);
        }

        return edad + " años, " + meses + " meses y " + dias + " días";
    };

    return (
        <div aria-multiselectable={true} className="card-collapse">
            <Card className="card-plain my-0">
                <CardHeader role="tab" className={`${open && "active"}`}>
                    <div data-toggle="collapse" className="expanded c-pointer" onClick={openCollapse}>
                        {"Dependientes "}&nbsp;&nbsp;
                        <i
                            className={
                                !open ? "now-ui-icons arrows-1_minimal-down" : "now-ui-icons arrows-1_minimal-up"
                            }
                        />
                    </div>
                </CardHeader>
                <Collapse isOpen={open}>
                    <Container className="text-center pl-0">
                        <div className={"table-responsive"}>
                            <table className="table table-striped table-hover">
                                <thead className="text-primary">
                                    <tr>
                                        <th className="text-left">Item</th>
                                        <th className="text-left">Dependiente/Beneficiario</th>
                                        <th className="text-left">Fc Nacimiento</th>
                                        <th className="text-left">Parentesco/Relación</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {list.map((item, index) => (
                                        <tr key={item.cdSubObjeto}>
                                            <td className="text-left">
                                                <span>{index + 1}</span>
                                            </td>
                                            <td className="text-left">
                                                <span>{item.dscSubobjeto}</span>
                                            </td>
                                            <td className="text-left">
                                                <span>{moment(item.fcNacimiento).local().format("DD/MMM/YYYY")}</span>
                                            </td>
                                            <td className="text-left">
                                                <span>{item.obsSubobjeto}</span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Container>
                </Collapse>
            </Card>
        </div>
    );
};
